import { render } from "./RemoveButton.vue?vue&type=template&id=1588ce71&scoped=true&ts=true"
import script from "./RemoveButton.vue?vue&type=script&lang=ts"
export * from "./RemoveButton.vue?vue&type=script&lang=ts"

import "./RemoveButton.vue?vue&type=style&index=0&id=1588ce71&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1588ce71"]])

export default __exports__